import { clickCopy } from '@/utils/public';
export default {
  props: {
    scenc: {
      type: String,
      default: ''
    },
    variables: {
      type: Object,
      default: () => {}
    },
    bgColor: {
      type: String,
      default: '#f2f2f2'
    }
  },
  data() {
    return {
      textVariable: [],
      linkVariable: []
    };
  },
  watch: {
    variables: {
      handler(val) {
        this.textVariable = (val === null || val === void 0 ? void 0 : val.text) || [];
        this.linkVariable = (val === null || val === void 0 ? void 0 : val.link) || [];
      },
      deep: true,
      immediate: true
    }
  },
  // created() {
  //   this.textVariable = this.variables?.text || [];
  //   this.linkVariable = this.variables?.link || [];
  // },
  methods: {
    copyVariable(item) {
      let value = '${' + item.mark + '}';
      clickCopy(value);
    }
  }
};